module.exports = __webpack_public_path__ + "img/bancontact_2024_10_23.027e02f.svg";